import React, { useState } from 'react';
import './Services.css';
import { useLanguage } from '../context/LanguageContext';

const Services = () => {
  const [activeTab, setActiveTab] = useState('all');
  const { t } = useLanguage();

  const categories = [
    { id: 'all', label: t('services.filterAll'), icon: 'fa-cubes' },
    { id: 'dev', label: t('services.filterDev'), icon: 'fa-laptop-code' },
    { id: 'mobile', label: t('services.filterMobile'), icon: 'fa-mobile-screen-button' },
    { id: 'consulting', label: t('services.filterConsulting'), icon: 'fa-sliders' }
  ];

  const servicesData = [
    {
      category: 'dev',
      icon: 'fa-globe',
      title: t('services.s1Title'),
      badge: t('services.s1Badge'),
      description: t('services.s1Desc'),
      features: [
        t('services.s1F1'),
        t('services.s1F2'),
        t('services.s1F3')
      ],
      tags: [t('services.s1T1'), t('services.s1T2'), t('services.s1T3')]
    },
    {
      category: 'mobile',
      icon: 'fa-brands fa-android',
      title: t('services.s2Title'),
      badge: t('services.s2Badge'),
      description: t('services.s2Desc'),
      features: [
        t('services.s2F1'),
        t('services.s2F2'),
        t('services.s2F3')
      ],
      tags: [t('services.s2T1'), t('services.s2T2'), t('services.s2T3'), t('services.s2T4')]
    },
    {
      category: 'dev',
      icon: 'fa-laptop-code',
      title: t('services.s3Title'),
      badge: t('services.s3Badge'),
      description: t('services.s3Desc'),
      features: [
        t('services.s3F1'),
        t('services.s3F2'),
        t('services.s3F3')
      ],
      tags: [t('services.s3T1'), t('services.s3T2'), t('services.s3T3'), t('services.s3T4')]
    },
    {
      category: 'dev',
      icon: 'fa-building-shield',
      title: t('services.s4Title'),
      badge: t('services.s4Badge'),
      description: t('services.s4Desc'),
      features: [
        t('services.s4F1'),
        t('services.s4F2'),
        t('services.s4F3')
      ],
      tags: [t('services.s4T1'), t('services.s4T2'), t('services.s4T3'), t('services.s4T4')]
    },
    {
      category: 'consulting',
      icon: 'fa-wand-magic-sparkles',
      title: t('services.s5Title'),
      badge: t('services.s5Badge'),
      description: t('services.s5Desc'),
      features: [
        t('services.s5F1'),
        t('services.s5F2'),
        t('services.s5F3')
      ],
      tags: [t('services.s5T1'), t('services.s5T2'), t('services.s5T3'), t('services.s5T4')]
    },
    {
      category: 'consulting',
      icon: 'fa-wrench',
      title: t('services.s6Title'),
      badge: t('services.s6Badge'),
      description: t('services.s6Desc'),
      features: [
        t('services.s6F1'),
        t('services.s6F2'),
        t('services.s6F3')
      ],
      tags: [t('services.s6T1'), t('services.s6T2'), t('services.s6T3'), t('services.s6T4')]
    }
  ];

  const filteredServices = activeTab === 'all'
    ? servicesData
    : servicesData.filter((s) => s.category === activeTab);

  const scrollToContact = () => {
    const el = document.getElementById('iletisim');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hizmetler" className="services-section">
      <div className="section-header">
        <div className="section-badge">
          <i className="fa-solid fa-cube"></i>
          <span>{t('services.badge')}</span>
        </div>
        <h2 className="section-title">{t('services.title')}</h2>
        <p className="section-subtitle">{t('services.subtitle')}</p>
      </div>

      {/* Category Tabs */}
      <div className="services-tabs">
        {categories.map((cat) => (
          <button
            key={cat.id}
            className={`services-tab-btn ${activeTab === cat.id ? 'active' : ''}`}
            onClick={() => setActiveTab(cat.id)}
          >
            <i className={`fa-solid ${cat.icon}`}></i>
            <span>{cat.label}</span>
          </button>
        ))}
      </div>

      {/* Services Grid */}
      <div className="services-grid">
        {filteredServices.map((service, index) => (
          <div key={index} className="service-card">
            <div className="service-card-top">
              <div className="service-icon-box">
                <i className={`fa-solid ${service.icon}`}></i>
              </div>
              <div className="service-badges">
                <span className="service-badge-pill">{service.badge}</span>
                <span className="service-number">0{index + 1}</span>
              </div>
            </div>

            <h3 className="service-title">{service.title}</h3>
            <p className="service-desc">{service.description}</p>

            {/* Bullet features */}
            <div className="service-features">
              {service.features.map((feat, fIndex) => (
                <div key={fIndex} className="service-feature-row">
                  <i className="fa-solid fa-circle-check"></i>
                  <span>{feat}</span>
                </div>
              ))}
            </div>

            {/* Bottom tags & CTA */}
            <div className="service-footer">
              <div className="service-tags">
                {service.tags.map((tag, tIndex) => (
                  <span key={tIndex} className="service-tag">{tag}</span>
                ))}
              </div>
              <button className="service-cta-link" onClick={scrollToContact}>
                <span>{t('nav.contact')}</span>
                <i className="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Custom Solution Callout */}
      <div className="services-callout">
        <div className="callout-content">
          <div className="callout-icon">
            <i className="fa-solid fa-wand-magic-sparkles"></i>
          </div>
          <div>
            <h3>{t('services.ctaTitle')}</h3>
            <p>{t('services.ctaDesc')}</p>
          </div>
        </div>
        <button className="btn btn-primary" onClick={scrollToContact}>
          <span>{t('services.ctaBtn')}</span>
          <i className="fa-solid fa-comments"></i>
        </button>
      </div>
    </section>
  );
};

export default Services;
